<cm-header-popup class="header-popup" [isSideNavStyle]="isSideNavStyle" (closeDialogEmitter)="onCloseDialog()">
  <div class="header-popup__paragraph">
    <h2 class="header-popup__title">{{ user?.fullName }}</h2>
    <h3 class="header-popup__subtitle ellipsis" title="{{ user?.email }}">{{ user?.email }}</h3>
  </div>
  <div class="header-popup__content">
    <div class="header-popup__content-section" (click)="loadImageCropper()" data-cy="header-popup-content">
      <mat-icon class="my-0 ml-0">photo_camera</mat-icon>
      <span> {{ 'profile.updatePhoto' | translate }} </span>
    </div>
    <cm-navigation-menu
      [displayMode]="profileDisplayMode"
      [navigationItems]="mobileNavigationItems"
      (click)="onCloseDialog()"
    ></cm-navigation-menu>
  </div>
</cm-header-popup>
